import { Input, OnDestroy } from "@angular/core";
import { Component, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { RestockTagClasses } from "src/app/models/purchasing.model";

@Component({
  selector: "app-restock-tags",
  templateUrl: "./restock-tags.component.html",
  styleUrls: ["./restock-tags.component.scss"],
})
export class RestockTagsComponent implements OnInit,OnDestroy {
  private destroy$ = new Subject<void>();
  constructor() {}

  ngOnInit(): void {}

  _className: any;
  set className(className: string) {
    this._className = {['tag--' + className]: true};   
  }
  get className() {
    return this._className;
  }

  @Input() set restockTag(restockTag: string) {
    
    this.setClass(restockTag);
    this._restockTag = restockTag;
  }

  private _restockTag: string;
  get restockTag(): string {
    return this._restockTag;
  }
  tooltipText:string='';

  setClass(restockTag) {
    restockTag = restockTag.toLowerCase();
    restockTag = restockTag.replace(/\s/g, "-");
    switch (restockTag) {
      case RestockTagClasses.OrderNow:
        this.className = RestockTagClasses.OrderNow;
        this.tooltipText="Items that will be out of stock in next 20 days or safety stock, + lead time on at least 1 sku";
        break;
      case RestockTagClasses.OutOfStock:
        this.className = RestockTagClasses.OutOfStock;
        this.tooltipText="Items that is out of stock even just in 1 sku and has no item qty to restock";
        break;
      case RestockTagClasses.OrderSoon:
        this.className = RestockTagClasses.OrderSoon;
        this.tooltipText="Items that will be out of stock in next range of the purchase days";
        break;
      case RestockTagClasses.OverStocked:
        this.className = RestockTagClasses.OverStocked;
        this.tooltipText="Items that have remaining days more then 120"
        break;
      case RestockTagClasses.NewItem:
        this.className = RestockTagClasses.NewItem;
        this.tooltipText="Items with no sales history"
        break;
      case RestockTagClasses.NoActionNeeded:
        this.className = RestockTagClasses.NoActionNeeded;
        this.tooltipText="Items that are stocked between purchase days-120(Overstocked ) days"
        break;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
  
}

